import React from 'react';

interface ScrollToBottomBtnProps {
  onClick: () => void;
  hasNewMessages: boolean;
  newMessagesCount: number;
}

export const ScrollToBottomBtn: React.FC<ScrollToBottomBtnProps> = ({
  onClick,
  hasNewMessages,
  newMessagesCount,
}) => {
  return (
    <button
      onClick={onClick}
      className="bg-brand-purple-900 hover:bg-brand-purple-500 text-white rounded-full p-3 shadow-lg transition-all duration-200 transform hover:scale-105 z-10 flex items-center justify-center"
      title={hasNewMessages ? 'Перейти к новым сообщениям' : 'Перейти вниз'}
    >
      <div className="relative">
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </svg>

        {/* Индикатор новых сообщений показывается ТОЛЬКО когда есть новые сообщения */}
        {hasNewMessages && newMessagesCount > 0 && (
          <span className="absolute -bottom-4 -left-4 bg-gray-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
            {newMessagesCount > 9 ? '9+' : newMessagesCount}
          </span>
        )}
      </div>
    </button>
  );
};
